import Comments from '../components/detailsTabs/comments/comments';
import Dates from '../components/detailsTabs/Dates/Dates';
import DatesCustom from '../components/detailsTabs/DatesCustom/DatesCustom';
import DatesCustomSup from '../components/detailsTabs/DatesCustomSup/DatesCustomSup';
import FAQ from '../components/detailsTabs/FAQ/FAQ';
import Included from '../components/detailsTabs/included/Included';
import Itinerary from '../components/detailsTabs/itinerary/Itinerary';
import Overview from '../components/detailsTabs/overView/Overview';
import Pickup from '../components/detailsTabs/pickup/Pickup';
import Places from '../components/detailsTabs/places/Places';
import GuidePrice from '../components/detailsTabs/Price/guidePrice/GuidePrice';
import Price from '../components/detailsTabs/Price/Price';
import Reviews from '../components/detailsTabs/reviews/Reviews';
import { Rooms } from '../components/detailsTabs/rooms/Rooms';
import Safety from '../components/detailsTabs/safety/safety';
import Stay from '../components/detailsTabs/stay/Stay';
import TermsDis from '../components/detailsTabs/termsDis/TermsDis';
import UserDates from '../components/detailsTabs/userDates/UserDates';
import DatesDetails from '../components/orgDetails/detailsTab/datesGuideCampAndCitivity/DatesDetails';
import SupDates from '../components/SupDates/SupDates';

const getDateComponent = (datesType, whichSection) => {
    if (datesType === 'custom') {
        return whichSection === 'support' ? DatesCustomSup : DatesCustom;
    }

    return whichSection === 'support' ? SupDates : Dates;
};

// Reviews API expects the short booking type
const FLOW_TO_TYPE = { trip: 'trip', guide: 'gu', activity: 'act', camp: 'camp' };

export const TAB_REGISTRY = [
    {
        id: 'itinerary',
        label: 'Itinerary',
        flows: ['trip'],
        roles: ['org', 'support', 'user'],
        render: ({ data, activeDay }) => <Itinerary data={data?.itinerary} activeDay={activeDay} />
    },
    {
        id: 'places',
        label: 'Places',
        flows: ['guide'],
        roles: ['org', 'support', 'user'],
        render: ({ data }) => <Places data={data?.places} />
    },
    {
        id: 'inc/exc',
        label: 'INC/EXC',
        flows: ['trip', 'guide', 'activity', 'camp'],
        roles: ['org', 'support', 'user'],
        render: ({ data }) => <Included dataInc={data?.included} dataExc={data?.excluded} />
    },
    {
        id: 'dates',
        label: 'Dates',
        flows: ['trip', 'guide', 'activity'],
        roles: ['org', 'support'],
        render: ({ data, whichSection, refresh }) => {
            const DateComponent = getDateComponent(data?.datesType, whichSection);

            return (
                <DateComponent
                    datesType={data?.datesType}
                    data={data?.unavailableDates}
                    refresh={refresh}
                    packData={data}
                />
            );
        }
    },
    {
        id: 'dates',
        label: 'Dates',
        flows: ['trip'],
        roles: ['user'],
        render: ({ data, dates }) => <UserDates datesType={data.datesType} packData={data} packDates={dates} />
    },
    {
        id: 'pickup',
        label: 'Pickup',
        flows: ['trip'],
        roles: ['org', 'support', 'user'],
        render: ({ data }) => <Pickup data={data?.price} />
    },
    {
        id: 'overview',
        label: 'Overview',
        flows: ['trip', 'guide', 'activity', 'camp'],
        roles: ['org', 'support', 'user'],
        render: ({ data }) => <Overview data={data?.overview} />
    },
    {
        id: 'rooms',
        label: 'Rooms',
        flows: ['trip'],
        roles: ['org', 'support'],
        render: ({ data }) => <Rooms data={data?.rooms} />
    },

    {
        id: 'stay',
        label: 'Stay',
        flows: ['trip'],
        roles: ['org', 'support', 'user'],
        render: ({ data }) => <Stay data={data?.stayDetails} />
    },
    {
        id: 'safety',
        label: 'Safety',
        flows: ['trip', 'guide', 'activity', 'camp'],
        roles: ['org', 'support', 'user'],
        render: ({ data }) => <Safety type={'safety'} data={data?.safety} />
    },
    {
        id: 'carry',
        label: 'Carry',
        flows: ['trip', 'guide', 'activity', 'camp'],
        roles: ['org', 'support', 'user'],
        render: ({ data }) => <Safety type={'carry'} data={data?.carry} />
    },
    {
        id: 'reviews',
        label: 'Reviews',
        flows: ['trip', 'guide', 'activity', 'camp'],
        roles: ['org', 'support', 'user'],
        render: ({ data, flow }) => <Reviews data={data} type={FLOW_TO_TYPE[flow] || 'trip'} />
    },
    {
        id: 'faq',
        label: 'FAQ',
        flows: ['trip', 'guide', 'activity', 'camp'],
        roles: ['org', 'support', 'user'],
        render: ({ data }) => <FAQ data={data?.FAQ} />
    },
    {
        id: 'terms',
        label: 'Terms',
        flows: ['trip', 'guide', 'activity', 'camp'],
        roles: ['org', 'support', 'user'],
        render: ({ data }) => <TermsDis data={data?.terms} />
    },
    {
        id: 'price',
        label: 'Price',
        flows: ['trip', 'guide', 'activity', 'camp'],
        roles: ['org', 'support'],
        render: ({ data }) => <Price data={data} datesType={data.datesType} group={data.group} />
    },
    {
        id: 'comments',
        label: 'Comments',
        flows: ['trip', 'guide', 'activity', 'camp'],
        roles: ['org', 'support'],
        render: ({ data }) => <Comments data={data?.pickupComments} />
    }
];

export function resolveTabs(registry, context) {
    return registry.filter((tab) => {
        const isValidFlow = tab.flows.includes(context.flow);
        const isValidRole = tab.roles.includes(context.role);

        // Hide Dates tab for users when datesType is not fixed
        if (tab.id === 'dates' && context.role === 'user' && context.data?.datesType !== 'fixed') {
            return false;
        }

        // Hide Stay tab when there are no stay details
        if (tab.id === 'stay') {
            const stay = context.data?.stayDetails;
            const hasStay =
                stay &&
                (stay.name ||
                    stay.location ||
                    stay.mapLink ||
                    stay.description ||
                    (stay.images && stay.images.length));
            if (!hasStay) return false;
        }

        return isValidFlow && isValidRole;
    });
}
